<template>
    <v-container class="pa-5" fluid>
        <page-title>
            {{ pageTitle }}
        </page-title>

        <v-row align="center">
            <v-col class="pb-0">
                <v-btn
                    text
                    color="primary"
                    class="pa-0"
                    :disabled="actionLoading.dieCutterLoading"
                    @click="close"
                >
                    <v-icon color="primary">
                        mdi-arrow-left
                    </v-icon>
                    Powrót do listy
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" xl="8" offset-xl="2">
                <v-container class="pa-0">
                    <v-row>
                        <v-col cols="12">
                            <h2 class="text-h6">
                                Parametry wykrojnika
                            </h2>
                        </v-col>
                        <v-col cols="12">
                            <v-card>
                                <v-card-text>
                                    <v-container v-if="isDMTDieCutter">
                                        <v-row>
                                            <v-col cols="12" sm="6">
                                                <v-autocomplete
                                                    v-model="dieCutter.productTypeId"
                                                    label="Wybierz rodzaj produktu"
                                                    :items="productTypes"
                                                    :filter="customFilter"
                                                    item-text="name"
                                                    item-value="id"
                                                    dense
                                                    outlined
                                                    :error-messages="productTypeErrors"
                                                    :disabled="!isAdmin"
                                                />
                                            </v-col>
                                            <v-col cols="12" sm="6">
                                                <v-text-field
                                                    v-model="dieCutter.format"
                                                    label="Format produktu"
                                                    outlined
                                                    dense
                                                    :error-messages="formatErrors"
                                                    :disabled="!isAdmin"
                                                />
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="5">
                                                <v-text-field
                                                    v-model="dieCutter.symbol"
                                                    label="Nazwa wykrojnika"
                                                    outlined
                                                    dense
                                                />
                                            </v-col>
                                            <v-col cols="12" sm="4">
                                                <v-text-field
                                                    v-model.number="dieCutter.price"
                                                    label="Cena wykrojnika"
                                                    outlined
                                                    dense
                                                    suffix="zł"
                                                />
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="5">
                                                <v-autocomplete
                                                    v-model="dieCutter.sheetFormatId"
                                                    label="Wybierz format arkusza"
                                                    :items="machineSheetFormats"
                                                    :filter="customFilter"
                                                    item-text="name"
                                                    item-value="id"
                                                    dense
                                                    outlined
                                                    :disabled="!isAdmin"
                                                />
                                            </v-col>
                                            <v-col cols="12" sm="2">
                                                <v-text-field
                                                    v-model="dieCutter.parts"
                                                    label="Ilość użytków"
                                                    type="number"
                                                    min="1"
                                                    outlined
                                                    dense
                                                    :disabled="!isAdmin"
                                                    @change="changeParts(dieCutter.parts)"
                                                />
                                            </v-col>
                                            <v-col cols="12" sm="5">
                                                <v-autocomplete
                                                    v-model="dieCutter.machineId"
                                                    label="Maszyna"
                                                    :items="machines"
                                                    :filter="customFilter"
                                                    item-value="id"
                                                    item-text="name"
                                                    no-data-text="Nie znaleziono maszyny"
                                                    outlined
                                                    dense
                                                    :disabled="!isAdmin"
                                                />
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="5">
                                                <v-file-input
                                                    v-model="currentDieCutterFile"
                                                    label="Plik wykrojnika"
                                                    accept="image/*, .pdf"
                                                    counter
                                                    placeholder="Wybierz plik"
                                                    prepend-icon="mdi-paperclip"
                                                    outlined
                                                    dense
                                                    :error-messages="currentDieCutterFileFileErrors"
                                                    :show-size="1000"
                                                    :disabled="!isAdmin || hasDieCutterFile"
                                                />
                                            </v-col>
                                            <v-col cols="auto">
                                                <v-btn
                                                    color="primary"
                                                    outlined
                                                    data-sentry-label="Wyślij plik"
                                                    :disabled="!currentDieCutterFile || hasDieCutterFile"
                                                    @click="addDieCutterFileAttachment"
                                                >
                                                    <v-icon left>
                                                        mdi-file-upload
                                                    </v-icon>
                                                    Wyślij
                                                </v-btn>
                                            </v-col>
                                            <v-col cols="12" sm="5">
                                                <div v-if="dieCutterFile" class="d-inline-flex align-center">
                                                    <v-overlay
                                                        color="white"
                                                        opacity="0.85"
                                                        absolute
                                                        :value="actionLoading.fileUploading"
                                                    >
                                                        <v-container class="pa-0">
                                                            <v-row justify="center">
                                                                <v-col cols="auto">
                                                                    <v-progress-circular
                                                                        :rotate="-90"
                                                                        :size="120"
                                                                        :width="4"
                                                                        :value="uploadingProgressValue"
                                                                        color="primary"
                                                                    >
                                                                        {{ uploadingProgressValue }}
                                                                    </v-progress-circular>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row justify="center">
                                                                <v-col cols="auto">
                                                                    <v-btn
                                                                        color="error"
                                                                        small
                                                                        data-sentry-label="Anuluj"
                                                                        outlined
                                                                        @click="abortUploadingDieCutterFileAttachment"
                                                                    >
                                                                        Anuluj
                                                                    </v-btn>
                                                                </v-col>
                                                            </v-row>
                                                        </v-container>
                                                    </v-overlay>
                                                    <template>
                                                        <div class="d-inline-flex">
                                                            {{ fileName(dieCutterFile.originalFileName) }}
                                                        </div>
                                                    </template>
                                                    <template>
                                                        <div class="d-inline-flex">
                                                            <v-tooltip :open-delay="tooltipDelay" top>
                                                                <template #activator="{on}">
                                                                    <v-btn
                                                                        icon
                                                                        data-sentry-label="Pobierz"
                                                                        :disabled="actionLoading.fileRemoving"
                                                                        v-on="on"
                                                                        @click="openInNewTab(dieCutterFile)"
                                                                    >
                                                                        <v-icon color="primary">
                                                                            mdi-download
                                                                        </v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <span>Pobierz</span>
                                                            </v-tooltip>
                                                            <v-tooltip :open-delay="tooltipDelay" top>
                                                                <template #activator="{on}">
                                                                    <v-btn
                                                                        v-if="isAdmin"
                                                                        icon
                                                                        :loading="actionLoading.fileRemoving"
                                                                        data-sentry-label="Usuń plik"
                                                                        v-on="on"
                                                                        @click="deleteDieCutterFileAttachment(dieCutterFile.id)"
                                                                    >
                                                                        <v-icon color="pink">
                                                                            mdi-delete
                                                                        </v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <span>Usuń</span>
                                                            </v-tooltip>
                                                        </div>
                                                    </template>
                                                </div>
                                                <v-alert
                                                    v-else
                                                    type="info"
                                                    text
                                                    border="left"
                                                    class="py-2"
                                                >
                                                    Nie dodano pliku dla wykrojnika.
                                                </v-alert>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="6">
                                                <v-select
                                                    v-model="dieCutter.rack"
                                                    label="Wybierz regał"
                                                    :items="racks"
                                                    dense
                                                    outlined
                                                    :disabled="!(isAdmin || isOperator)"
                                                    @change="getShelves(true)"
                                                />
                                            </v-col>
                                            <v-col cols="12" sm="6">
                                                <v-select
                                                    v-model="dieCutter.shelf"
                                                    label="Wybierz półkę"
                                                    :items="shelves"
                                                    dense
                                                    outlined
                                                    :error-messages="shelfErrors"
                                                    :disabled="!(isAdmin || isOperator)"
                                                />
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                    <v-container v-else>
                                        <v-row>
                                            <v-col cols="12" sm="4">
                                                <v-text-field
                                                    v-model="dieCutter.symbol"
                                                    label="Symbol"
                                                    outlined
                                                    dense
                                                    :error-messages="symbolErrors"
                                                    :disabled="!isAdmin"
                                                />
                                            </v-col>
                                            <v-col cols="12" sm="3">
                                                <v-text-field
                                                    v-model="dieCutter.parts"
                                                    label="Ilość użytków"
                                                    type="number"
                                                    min="1"
                                                    outlined
                                                    dense
                                                    :disabled="!isAdmin"
                                                    @change="changeParts(dieCutter.parts)"
                                                />
                                            </v-col>
                                            <v-col cols="12" sm="5">
                                                <v-autocomplete
                                                    v-model="dieCutter.machineId"
                                                    label="Maszyna"
                                                    :items="machines"
                                                    :filter="customFilter"
                                                    item-value="id"
                                                    item-text="name"
                                                    no-data-text="Nie znaleziono maszyny"
                                                    outlined
                                                    dense
                                                    :disabled="!isAdmin"
                                                />
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-btn
                                v-if="isAdmin || isOperator"
                                color="success"
                                medium
                                class="mr-3"
                                data-sentry-label="Zapisz"
                                :loading="actionLoading.dieCutterLoading"
                                @click="saveDieCutter"
                            >
                                Zapisz
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import store from '@/./store'
import { appConfig, apiConfig } from '@/config'
import PageTitle from '@/components/common/PageTitle'
import tooltipDelay from '@/mixins/tooltip'
import parse from '@/mixins/parse'
import { hasUserPermission } from '@/utils/permissionsHandler'
import { errorHandler } from '@/utils/errorHandler'
import { requiredIf } from 'vuelidate/lib/validators'
import customFilters from '@/mixins/customFilters'

const DIE_CUTTER_CF_ID = 2, DIE_CUTTER_DMT_ID = 1

export default {
    name: 'DieCutter',
    components: {
        PageTitle,
    },
    mixins: [ tooltipDelay, parse, customFilters ],
    beforeRouteEnter(to, from, next) {
        if (typeof to.params.id !== 'undefined') {
            store.dispatch('configurations/tools/getDieCutter', to.params.id)
                .then(response => {
                    Promise.all([
                        store.dispatch('configurations/getProducts', {
                            paginate: '',
                            query: '?isDieCutterRequired=true'
                        }),
                        store.dispatch('configurations/getMachineSheetFormats'),
                        store.dispatch('configurations/getMachines', {
                            paginate: '',
                            query: '?productionDepartment_id=2'}),
                        store.dispatch('configurations/tools/getLocalizationRacks', {localizationTypeId: 20})
                    ])
                        .then(responses => {
                            next(vm => {
                                vm.action = 'updateDieCutter'
                                vm.dieCutter = Object.assign({}, response.data)
                                vm.productTypes = responses[0].data.results
                                vm.machineSheetFormats = responses[1].data.results
                                vm.machines = responses[2].data.results
                                vm.racks = responses[3].data.racks
                                vm.dieCutterFile = vm.dieCutter.attachment
                                vm.pageTitle = `Wykrojnik - ${response.data.symbol}`
                                if (vm.dieCutter.rack) vm.getShelves(false)
                            })
                        })
                        .catch(error => {
                            next(error)
                            errorHandler(error)
                        })
                })
                .catch(error => {
                    next(error)
                    errorHandler(error)
                })
        } else if (to.params.typeId === DIE_CUTTER_CF_ID) {
            Promise.all([
                store.dispatch('configurations/getMachines', {
                    paginate: '',
                    query: '?productionProcess_id=36'}), //sztancowanie
                store.dispatch('configurations/tools/getLocalizationRacks', {localizationTypeId: 20})
            ])
                .then(responses => {
                    next(vm => {
                        vm.machines = responses[0].data.results
                        vm.action = 'createDieCutter'
                        vm.pageTitle = 'Tworzenie wykrojnika'
                        vm.typeId = to.params.typeId
                        vm.dieCutter.typeId = to.params.typeId
                    })
                })
                .catch(error => {
                    next(error)
                    errorHandler(error)
                })
        } else {
            Promise.all([
                store.dispatch('configurations/getProducts', {
                    paginate: '',
                    query: '?isDieCutterRequired=true'
                }),
                store.dispatch('configurations/getMachineSheetFormats'),
                store.dispatch('configurations/getMachines', {
                    paginate: '',
                    query: '?productionProcess_id=36'}), //sztancowanie
                store.dispatch('configurations/tools/getLocalizationRacks', {localizationTypeId: 20})
            ])
                .then(responses => {
                    next(vm => {
                        vm.productTypes = responses[0].data.results
                        vm.machineSheetFormats = responses[1].data.results
                        vm.machines = responses[2].data.results
                        vm.racks = responses[3].data.racks
                        vm.action = 'createDieCutter'
                        vm.pageTitle = 'Tworzenie wykrojnika'
                        vm.dieCutter.typeId = to.params.typeId
                        vm.typeId = to.params.typeId
                    })
                })
                .catch(error => {
                    next(error)
                    errorHandler(error)
                })
        }
    },
    data() {
        return {
            pageTitle: null,
            dieCutter: {
                productTypeId: null,
                rack: null,
                shelf: null,
                format: null,
                typeId: null,
                price: null
            },
            dieCutterFile: null,
            typeId: null,
            productTypes: [],
            productFormats: [],
            machineSheetFormats: [],
            machines: [],
            racks: [],
            shelves: [],
            action: null,
            currentDieCutterFile: null,
            actionLoading: {
                dieCutterLoading: false,
                fileUploading: false,
                fileRemoving: false
            },
        }
    },
    validations() {
        return {
            dieCutter: {
                symbol: {
                    required: requiredIf(function() {
                        return this.dieCutter.typeId === DIE_CUTTER_CF_ID
                    })
                },
                productTypeId: {
                    required: requiredIf(function() {
                        return this.dieCutter.typeId === DIE_CUTTER_DMT_ID
                    })
                },
                format: {
                    required: requiredIf(function() {
                        return this.dieCutter.typeId === DIE_CUTTER_DMT_ID
                    })
                },
                shelf: {
                    required: requiredIf(function() {
                        return this.dieCutter.rack && !this.dieCutter.shelf
                    })
                }
            },
            currentDieCutterFile: {
                isValid: (value) => {
                    if (value) {
                        return value.size < appConfig.configurations.tools.dieCutters.attachmentSize * 1024 * 1024
                    }

                    return true
                }
            }
        }
    },
    computed: {
        isDMTDieCutter() {
            return this.dieCutter.typeId === DIE_CUTTER_DMT_ID
        },
        isAdmin() {
            return hasUserPermission('die_cutters_admin_create') || hasUserPermission('die_cutters_admin_update')
        },
        isOperator() {
            return hasUserPermission('die_cutters_update')
        },
        hasDieCutterFile() {
            return this.dieCutterFile !== null
        },
        uploadingProgressValue() {
            return this.$store.state.common.progress.value
        },
        productTypeErrors() {
            const errors = []

            if (!this.$v.dieCutter.productTypeId.$dirty) return errors
            !this.$v.dieCutter.productTypeId.required && errors.push('Proszę podać rodzaj produktu wykrojnika.')

            return errors
        },
        symbolErrors() {
            const errors = []

            if (!this.$v.dieCutter.symbol.$dirty) return errors
            !this.$v.dieCutter.symbol.required && errors.push('Proszę podać symbol wykrojnika.')

            return errors
        },
        formatErrors() {
            const errors = []

            if (!this.$v.dieCutter.format.$dirty) return errors
            !this.$v.dieCutter.format.required && errors.push('Proszę podać format wykrojnika.')

            return errors
        },
        shelfErrors() {
            const errors = []

            if (!this.$v.dieCutter.shelf.$dirty) return errors
            !this.$v.dieCutter.shelf.required && errors.push('Proszę wybrać półkę.')

            return errors
        },
        currentDieCutterFileFileErrors() {
            if (!this.currentDieCutterFile) return

            const errors = []

            if (!this.$v.currentDieCutterFile.$dirty) return errors
            !this.$v.currentDieCutterFile.isValid && errors.push(`Przekroczono dopuszczalny rozmiar pliku: ${appConfig.configurations.tools.dieCutters.attachmentSize}MB.`)

            return errors
        },
    },
    methods: {
        addDieCutterFileAttachment() {
            this.$v.currentDieCutterFile.$touch()

            if (this.$v.currentDieCutterFile.$invalid) return

            const formData = new FormData()

            formData.append('file', this.currentDieCutterFile)

            this.actionLoading.fileUploading = true

            this.$store.dispatch('configurations/tools/addDieCutterFileAttachment', {
                formData: formData,
                abort: false
            })
                .then(response => {
                    this.dieCutterFile = response.data
                    this.currentDieCutterFile = null
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading.fileUploading = false
                })
        },
        abortUploadingDieCutterFileAttachment() {
            this.$store.dispatch('configurations/tools/addDieCutterFileAttachment', {
                formData: null,
                abort: true
            })
                .catch(error => {
                    errorHandler(error)
                })
        },
        deleteDieCutterFileAttachment(id) {
            this.actionLoading.fileRemoving = true
            this.$store.dispatch('configurations/tools/deleteDieCutterFileAttachment', id)
                .then(() => {
                    this.dieCutterFile = null
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading.fileRemoving = false
                })
        },
        changeParts(value) {
            this.dieCutter.parts = this.parseEmptyStringToNull(value)
        },
        saveDieCutter() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }
            this.actionLoading.dieCutterLoading = true
            this.dieCutter.attachmentId = this.dieCutterFile ? this.dieCutterFile.id : null
            this.$store.dispatch(`configurations/tools/${this.action}`, this.dieCutter)
                .then(() => {
                    this.close()
                })
                .catch(error => {
                    errorHandler(error)
                    this.actionLoading.dieCutterLoading = false
                })
        },
        close() {
            this.$v.$reset()
            this.actionLoading.dieCutterLoading = false
            this.$router.push({ name: 'configurationsToolsDieCutters'})
                .catch(error => {
                    errorHandler(error)
                })
        },
        fileName(file) {
            const words = file.split('/')

            return words[words.length - 1]
        },
        openInNewTab(file) {
            const mediaRoot = apiConfig.FACTORYBASE_API_URI

            window.open(`${mediaRoot}${file.file_url}`, '_blank').focus()
        },
        getShelves(resetDieCutterShelf) {
            if (resetDieCutterShelf) this.dieCutter.shelf = null

            this.$store.dispatch('configurations/tools/getLocalizationShelves', {
                hallId: 20,
                localizationTypeId: 20,
                rack: this.dieCutter.rack
            })
                .then(response => {
                    this.shelves = response.data.shelves
                })
                .catch(error => {
                    errorHandler(error)
                })
        }
    },
}
</script>